import PatientOverviewStressProgress from 'dashboard/templates/views/Patient/Stress/PatientOverviewStressProgress';

const navigationSteps = {
    nextDiscussionStep: {
        PatientRecordProgressStatus: 'PatientRecordProgressGoalSetting',
    },
    prevDiscussionStep: {
        PatientRecordProgressGoalSetting: 'PatientRecordProgressStatus',
    }
}

export default {
    path: 'progress',
    name: 'PatientRecordStressProgress',
    props: navigationSteps,
    component: PatientOverviewStressProgress,
    meta: {
        // title: 'Patient Record - Stress Relief - Progress',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.stressReliefSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress')}`,
        // title: 'Stress Relief - Status',
        title: t => `${t('screens.stressReliefSettingsScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    },
    children: [
    ],
};
